import { createI18nText } from '@hilma/netina2all';

const associationRegistrationText = createI18nText({
    he: {
        title: 'בקשה לרישום עמותה חדשה לשנת',
        conditions: {
            title: 'התנאים להצטרפות כעמותה למיזם:',
            section46: 'סעיף 46 לצרכי מס',
            properReport: 'אישור נוהל תקין',
            social: 'עמותה חברתית!',
            year: '*ההרשמה היא לשנת',
            choose: '*מתנות קטנות יכולה לבחור את העמותות המשתתפות במיזם לפי בחירתה'
        },
        form: {
            assoName: 'שם העמותה',
            conName: 'שם איש הקשר (שם פרטי + שם משפחה)',
            phone: 'טלפון נייד',
            email: 'כתובת מייל',
            has46: 'לעמותה סעיף 46',
            hasReport: 'לעמותה אישור ניהול תקין',
            responsibility: 'על העמותה להעמיד שני רכבים עם שני נהגים ביום חלוקת המוצרים בסמוך לפורים',
        },
        sendBtn: 'שלח',
        popUp: {
            title: 'נשלחה בקשה לרישום עמותה חדשה',
            text: 'אנו נחזור אליך בהקדם עם מידע נוסף להמשך התהליך.',
            btn: 'חזרה לעמוד הבית'
        },
    },
    en: {
        title: 'Request To Sign Up an Organization for',
        conditions: {
            title: 'Conditions for Joining the Project as an Association:',
            section46: 'Section 46 for tax deduction purposes',
            properReport: 'Proper Management report',
            social: 'Non-profit organization',
            year: '*Registration is for',
            choose: '*Matanot Ktanot can choose which associations will participate in the project'
        },
        form: {
            assoName: 'Organization Name',
            conName: 'Contact Name',
            phone: 'Cellphone Number',
            email: 'Email Address',
            has46: 'The association has Section 46',
            hasReport: 'The association has a proper management report',
            responsibility: 'The association must have two vehicles with two drivers on the day the products are distributed near Purim',
        },
        sendBtn: 'Send',
        popUp: {
            title: 'The request has been sent to register a new association',
            text: "We'll be in touch soon",
            btn: 'Home'
        },
    }
});

export default associationRegistrationText;